module.exports = __webpack_public_path__ + "img/filigrana-chi-siamo-1.30f591c8.png";